exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@media screen and (max-width: 750px) {\n.leftBox[data-v-679bd3ef] {\n    width: 100%;\n    margin-top: 0;\n}\n.rightBox[data-v-679bd3ef] {\n    display: none;\n}\n}\n", ""]);

